// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"a6e0c5ae81bd07a6","925":"c051c61d79662945"}[chunkId] + ".css";
};